import { type JSX } from 'solid-js';
import './SettingsCog.css';

export interface SettingsCogProps {
  id: string;
  active: boolean;
  onClick: () => void;
  position?: 'absolute' | 'relative';
  style?: Record<string, string>;
}

export function SettingsCog(props: SettingsCogProps): JSX.Element {
  return (
    <button
      id={props.id}
      class="settings-cog"
      classList={{ active: props.active }}
      onClick={props.onClick}
      style={{ position: props.position ?? 'absolute', ...props.style }}
      aria-label="Settings"
    >
      <i data-lucide="settings" />
    </button>
  );
}
